import { Component, ChangeDetectionStrategy } from '@angular/core'
import { RouterLink, RouterLinkActive } from '@angular/router'
import { mobileNavItems } from '../../client-navigation.data'

@Component({
    selector: 'app-client-bottom-nav',
    imports: [RouterLink, RouterLinkActive],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './client-bottom-nav.component.html',
})
export class ClientBottomNavComponent {
    items = mobileNavItems()
}
